import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center h-full text-white" }
const _hoisted_2 = { class: "relative w-full h-full" }
const _hoisted_3 = { class: "w-full h-full rounded-full overflow-hidden" }
const _hoisted_4 = { class: "ml-1" }


import TokenLogo from './TokenLogo.vue'
interface Props {
  symbol: string
  logoSize?:string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    symbol: null,
    logoSize: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(TokenLogo, {
          symbol: __props.symbol,
          class: _normalizeClass(__props.logoSize ? __props.logoSize :'w-4 h-4 mr-1')
        }, null, 8, ["symbol", "class"])
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.symbol), 1)
  ]))
}
}

})